import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Customer } from '@squareup/sq-addons-web-sdk'
import { RequestContext } from 'utils/pos'

export type State = {
  customer: Customer | null
  context: RequestContext | null
  addedToSale: boolean
}

const slice = createSlice({
  name: 'customer',
  initialState: {
    customer: null,
    context: null,
    addedToSale: false,
  } as State,
  reducers: {
    setCustomer: (
      state,
      action: PayloadAction<{ customer: Customer; context: RequestContext }>
    ) => {
      const { customer, context } = action.payload
      state.customer = customer
      state.context = context
    },
    clearCustomer: state => {
      state.customer = null
      state.context = null
      state.addedToSale = false
    },
    customerAddedToSale: state => {
      state.addedToSale = true
    },
    customerRemovedFromSale: state => {
      state.addedToSale = false
    },
  },
})

export const {
  setCustomer,
  customerAddedToSale,
  customerRemovedFromSale,
  clearCustomer,
} = slice.actions

export default slice.reducer
